import React from "react";
import styled from "styled-components";

import Card from '../card/card';

const StackWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

const CombinationWrapper = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: -150px;
    margin-right: 48px;
    &:last-child {
        margin-bottom: 0px;
    }
`;

const CardStack = ({ cards, cardHeight }) => {

    return (
        <StackWrapper>
            {cards.map((value, index) => (
                <CombinationWrapper key={index}>
                    {value.map((card) => (
                        <Card key={card} value={card} height={cardHeight || 150}/>
                    ))}
                </CombinationWrapper>
            ))}
        </StackWrapper>
    );
};

export default CardStack;